const _version = "3.7.3"
function version() {
    return _version
}
export default version
